import { createDataStore } from "./common";

export default createDataStore({
  storeKey: "naics",
  endpoint: process.env.REACT_APP_PLACES_API_HOST + "/naics",
  idKey: "naics_code"
});
